import {IMuWidget} from "../IMuWidget";
import {DmsCL} from "../generated/DmsCL";
import {CellValueTranformerEvent, ColumnInfo, UiTable, UiTableCell} from "../components/UiTable";
import {focusFirstVisibleControl, formatDate, formatNumber} from "../Utils";
import {AnyElement, MuWidget} from "mu-widget/lib/MuWidget";
import {UiBuSubjectEditor} from "./UiBuSubjectEditor";
import {CachedPromise} from "../CachedPromise";
import {MuRouter, MuRouterContext} from "mu-widget/lib/MuRouter";
import {BaseModule} from "./BaseModule";
import {BaseEditor} from "../BaseEditor";
import {MultiUpload} from "../MultiUpload";
import {BuSubject, DmsDocument, DmsDocumentType, DmsDocumentTypeOpts, OrgProject} from "./Types";
import {UiDmsAttaches} from "./UiDmsAttaches";
import {UiBuSubjects} from "./UiBuSubjects";
import {UiDmsDocuments} from "./UiDmsDocuments";
import {UiDmsOrgProjects} from "./UiDmsOrgProjects";
import {UiDocumentListPreview} from "./UiDocumentListPreview";
import {EntityType} from "../Types";
import {UiTomSelect} from "../components/UiTomSelect";
import {DelayedSingleLauncher} from "../../DelayedSingleLauncher";

export class UiDms extends MuWidget<MuWidget, {}, {
	subjects: UiBuSubjects,
	documents: UiDmsDocuments,
	suppliers: UiBuSubjects,
	customers: UiBuSubjects,
	projects: UiDmsOrgProjects,
	ibsFilter: UiTomSelect
}>
{
	public static instance: UiDms;
	cpDmsDocumentClass: CachedPromise<any> = new CachedPromise<any>(() => this.cl.withMessage('Načítám typy smluv').getDmsDocumentClasses());
	cpDmsDocumentType: CachedPromise<DmsDocumentType[]> = new CachedPromise(() => this.cl.withMessage('Načítám typy dokumentů').getDmsDocumentTypes());
	cpMyBuSubjects: CachedPromise<any> = new CachedPromise<any>(() => this.cl.withMessage('Načítám subjekty').getMyBuSubjects());
	cpCurrencies: CachedPromise<any> = new CachedPromise<any>(() => this.cl.withMessage('Načítám měny').getAllCurrencies());
	cpOrgDivision = new CachedPromise(() => this.cl.withMessage('Načítám organizační jednotky').getOrgDivisions());
	cpDmsAttachType = new CachedPromise(() => this.cl.withMessage('Načítám typy příloh').getAllDmsAttachTypes({}));
	cpStates = new CachedPromise(() => this.cl.withMessage('Načítám stavy').getAllStates({}));
	router: MuRouter = new MuRouter();
	private baseUrl: string = "";
	securityLevels: {title: string, id: string}[] = [];
	isAdmin: boolean = false;
	beforeIndex()
	{
		UiDms.instance = this;
		this.cl = new DmsCL(this.clUrl);
		this.container.innerHTML = `
			<div class="display-flex gap-4px">
				<label><input type="checkbox" mu-id="ibsFilterActive"> Zobrazit jen za firmu</label>
				<div class="flex-grow-1" mu-widget="UiTomSelect" mu-id="ibsFilter" mu-bind="buSubjectId" mu-params='{"multiple":true}'></div>
			</div>
			<div>
				<ul class="nav nav-tabs" mu-id="tabs">
					<li><a mu-tag="showSectionBt" data-tab="documents" class="a">Dokumenty</a></li>`
				+ (this.isAdmin ? '<li><a mu-tag="showSectionBt" data-tab="subjects" class="a">Obchodní subjekty</a></li>' : '')
				+ `<li><a mu-tag="showSectionBt" data-tab="suppliers" class="a">Dodavatelé</a></li>
					<li><a mu-tag="showSectionBt" data-tab="customers" class="a">Odběratelé</a></li>
					<li><a mu-tag="showSectionBt" data-tab="projects" class="a">Projekty</a></li>
				</ul>
			</div>			
			<div mu-id="tabContents">
				<div data-tab="documents" mu-id="documents" mu-widget="UiDmsDocuments"></div>`
			+ (this.isAdmin ? '<div data-tab="subjects" mu-id="subjects" mu-widget="UiBuSubjects"></div>' : '')
			+ `<div data-tab="suppliers" mu-id="suppliers" mu-widget="UiBuSubjects" mu-params='{"contractFilter":"supplier"}'></div>
				<div data-tab="customers" mu-id="customers" mu-widget="UiBuSubjects" mu-params='{"contractFilter":"customer"}'></div>
				<div data-tab="projects" mu-id="projects" mu-widget="UiDmsOrgProjects"></div>
			</div>
			
			<div mu-id="modals" class="modal-b"></div>
			
			<table style="display: none"><tr>
				<td mu-template="shared:tdLink" mu-widget="UiDocumentLinkCell"></td>
				<td mu-template="shared:tdAmountCurrency" class="number" mu-widget="UiTdAmountCurrency"></td>
			</tr></table>
		`;
		this.router.pathPrefix = this.baseUrl.replace(/\/+$/, "");
		const dra = (context: MuRouterContext) => {
			const tab = context.parameters.tab?.toString() || 'documents';
			this.showTab(tab, false);
			let module = this.muNamedWidget[tab] as unknown as BaseModule;
			const listParams = context.parameters[tab + "_list"];
			if (listParams) module.setupList(JSON.parse(listParams as string));
			if (context.parameters.id && module) {
				module.loadItem(parseInt(context.parameters.id as string));
			}
		};
		this.router.persistentKeys = ["tab", "subjects_list", "documents_list"];
		this.router.lastName = "root";
		this.router.addRoute('default', '/<tab>/<id>', dra);
		this.router.addRoute('open', '/<tab>', dra);
		this.router.addRoute('root', '/', dra);
	}

	public clUrl: string = "";

	// @ts-ignore
	public cl: DmsCL;

	public async getDocumentTypeOpts(documentTypeId: number): Promise<DmsDocumentTypeOpts>
	{
		return (await this.cpDmsDocumentType.fetch()).find((t) => t.id == documentTypeId)?.opts;
	}

	public async getDmsDocumentType(documentTypeId: number|string): Promise<DmsDocumentType>
	{
		return (await this.cpDmsDocumentType.fetch()).find((t: any) =>
			(typeof documentTypeId === "string" ? t.code : t.id) == documentTypeId);
	}

	public openInModal<T extends MuWidget<BaseModule>|any>(
		widget: string,
		title: string|null = null,
		params: any = {},
		focusFirstInput = true
	): T
	{
		const el = document.createElement("div") as AnyElement;
		this.ui.modals.appendChild(el);
		this.updateModals();
		el.classList.add("modal-i");
		el.setAttribute("mu-widget", widget);
		if (title) el.innerHTML = `<div class="modal-title"><h2 mu-id="modalTitle"></h2><span class="close" mu-id="btCloseModal" mu-click="muRemoveSelf">×</span> </div>`;
		const w = this.muActivateWidget(el, {
			widget: widget,
			params: params, // JSON.stringify(params)
		}, params) as unknown as T;
		if (title) { // @ts-ignore
			w.ui.modalTitle.innerText = title;
		}
		if (focusFirstInput) {
			focusFirstVisibleControl(el as HTMLElement);
		}
		// @ts-ignore
		setTimeout(() => w.container.scrollIntoView(), 200);

		return w;
	}

	afterIndex() {
		super.afterIndex();
		this.ui.modals.addEventListener(
			"DOMNodeRemoved",
			(ev) => setTimeout(
				() => this.updateModals(ev),
				1
			)
		);
		this.updateModals();

		(async () => {
			this.muNamedWidget.ibsFilter.init();
			this.muNamedWidget.ibsFilter.bindItems((await UiDms.instance.cpMyBuSubjects.fetch()).read);		// this.cl.getDocuments({});
		})();

		this.updateIbsFilterUi();


		/* const documentList = this.muNamedWidget.documentList;
		documentList.columns = [
			new ColumnInfo({field: "id", name: "ID"}),
			new ColumnInfo({field: "evidenceUid", name: "Číslo"}),
			new ColumnInfo({field: "dmsDocumentTypeName", name: "Typ"}),
			new ColumnInfo({field: "dateFrom", name: "Od", transformContent: (v,columnInf,w) => formatDate("d.m.Y", v)}),
			new ColumnInfo({field: "dateTo", name: "Do", transformContent: (v,columnInf,w) => formatDate("d.m.Y", v)}),
		];
		documentList.data = [
			{
				id: 123,
				evidenceUid: "45874ICT2020",
				dmsDocumentTypeName: "Smlouva bla",
				dateFrom: new Date(),
				dateTo: new Date(),
			},
			{
				id: 123,
				evidenceUid: "77874ICT2020",
				dmsDocumentTypeName: "Smlouva ble",
				dateFrom: new Date(),
				dateTo: new Date(),
			}
		]
		documentList.render(); */
		setTimeout(() => this.router.route(), 1000);

		// this.openInModal<UiBuSubjectEditor>("UiBuSubjectEditor", "Upravit subjekt");

	}

	documentList_order(ev: any, field: string, dir: string) {
		console.log({ev, field, dir});
	}

	documentList_filter(ev: any, field: string) {
		console.log({ev, field});
	}

	showSectionBt_click(ev: Event) {
		// alert((ev.target as HTMLElement).getAttribute('data-tab'));
		// @ts-ignore
		this.showTab(ev.target.dataset.tab);
	}

	private updateModals(ev: any = null) {
		this.muVisible(this.ui.modals.children.length > 0, 'modals');
		// console.log(ev);
	}

	public openBuSubjectEditor(id: number|null): UiBuSubjectEditor
	{
		// @ts-ignore
		const ed = this.openInModal<UiBuSubjectEditor>("UiBuSubjectEditor", id ? "Upravit subjekt" : "Přidat subjekt");
		if (id) ed.loadItem(id);
		ed.savedPromise.then(() => ed.muRemoveSelf());
		return ed;
	}

	public openDmsDocumentEditor(id: number|null, initData: any = {}): BaseEditor {
		const editor = UiDms.instance.openInModal(
			id
				? "UiDmsDocumentEditor"
				: "UiNewDocumentAttach",
			id
				? "Upravit dokument"
				: "Vytvořit dokument"
		) as unknown as BaseEditor;
		if (id) editor.loadItem(id);
		if (initData) editor.muBindData(initData);
		editor.savedPromise.then(() => {
			this.muNamedWidget.documents.loadList();
			editor.muRemoveSelf();
		});
		return editor;
	}

	public openAttaches(dmsDocument: DmsDocument): UiDmsAttaches
	{
		const atts = this.openInModal<UiDmsAttaches>("UiDmsAttaches", "Přílohy k dokumentu " + getDocumentName(dmsDocument));
		atts.showForDmsDocument(dmsDocument);

		return atts;
	}


	private showTab(tab: string, updateUrl = true) {
		// @ts-ignore
		for(const el of this.ui.tabContents.children) {
			const etab = el.dataset.tab;
			el.style.display = etab == tab ? "" : "none";
		}
		// @ts-ignore
		for(const el of this.ui.tabs.children) {
			const etab = el.children[0].dataset.tab;
			el.classList.toggle('active', etab == tab);
		}
		if (updateUrl) {
			this.router.push(null, { tab: tab });
		}
	}

	openDocumentsPreview(entity: EntityType, id: number, entityData: BuSubject|OrgProject|DmsDocument) {
		const listPreview = UiDms.instance.openInModal<UiDocumentListPreview>('UiDocumentListPreview', "...");
		listPreview.showFor(entity, id, entityData);
	}

	ibsFilterActive_change() {
		this.updateIbsFilter();
		this.updateIbsFilterUi();
	}

	ibsFilter_change() {
		this.updateIbsFilter();
	}

	updateIbsFilter() {
		this.ibsReloadDL.send();
	}

	protected ibsReloadDL: DelayedSingleLauncher = new DelayedSingleLauncher(3, () => {
		const f = this.ui.ibsFilterActive.checked
			? this.muNamedWidget.ibsFilter.value || null
			: null;

		if (JSON.stringify(this.cl.context.ibsFilter) == JSON.stringify(f)) return;

		this.cl.context.ibsFilter = f;
		// this.muNamedWidget.projects
		// this.muNamedWidget.subjects
		this.muNamedWidget.customers.bReload_click();
		this.muNamedWidget.suppliers.bReload_click();
		this.muNamedWidget.documents.bReload_click();
		this.muNamedWidget.projects.bReload_click();
	});

	private updateIbsFilterUi() {
		this.muVisible(this.ui.ibsFilterActive.checked, 'ibsFilter');
		if (this.ui.ibsFilterActive.checked) this.muNamedWidget.ibsFilter.tom.focus();
	}
}

export class UiTdAmountCurrency extends UiTableCell
{
	render(value: any, row: any, ev: CellValueTranformerEvent) {
		this.container.innerHTML = formatNumber(value, 2) + (row.currency?.code || "");
	}
}

export function getDocumentName(dmsDocument: DmsDocument): string
{
	return dmsDocument.evidenceUid + ' ' + (dmsDocument.name || '');
}

export function getBuSubjectName(buSubject: BuSubject): string
{
	return buSubject.name + ' (' + buSubject.ic + ')';
}

export function getOrgProjectName(orgProject: OrgProject): string
{
	return orgProject.name + ' (' + orgProject.code + ')';
}
